import { createVNode as n, mergeProps as p } from "vue";
import T from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ArrowTopTwoTone.js";
import m from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(m, p(t, {
    icon: T
  }), null);
};
o.displayName = "ArrowTopTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
